import React from 'react';
import { connect } from 'react-redux';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { deliveryAddressFormUpdate, deliveryAddressFormError } from '../../actions/deliveryAddressForm';
import { addDeliveryAddress } from '../../actions/auth';
import { setAccountPanel } from '../../actions/panels';
import housecurrent from '../../assets/images/house-current.svg';

import { ModalCloseButton } from '../common/ModalCloseButton';

class NewDeliveryAddress extends React.Component {

    constructor(props) {
        super(props);

        this.onAddDeliveryAddressButtonPress = this.onAddDeliveryAddressButtonPress.bind(this);
    }

    componentDidMount() {
        
        // nothing here yet, delete if not required
    }

    onAddDeliveryAddressButtonPress() {

        const { token, address, instructions, lat, lng, dispatch } = this.props;

        // basic error checking
        if (address.trim() === "") {
            dispatch(deliveryAddressFormError("Please enter an address."));
        }
        else {
            dispatch(addDeliveryAddress({ token, address, instructions, lat, lng }));
        }
    }

    render() {
        return (
            <div className="breakpointContainer">
                
                <div className="close-button">   
                    <ModalCloseButton 
                        clickAction={() => this.props.dispatch(setAccountPanel('delivery_addresses'))} 
                    />
                </div>

                <div className="item-info-wrapper">
                    <h2 className="heading in-item">Add a New Delivery Address</h2>
                    <p className="fine-print-small">Don't worry, we only ask for this information once!</p>
                    {(this.props.error != "") && <p className="error-text">{this.props.error}</p>}

                    <div className="w-form">
                        {/* Input fields in here (same styles as the ) */}
                        
                        <GooglePlacesAutocomplete
                            selectProps={{
                                value: this.props.delivery_address,
                                onChange: (e) => {
                                    this.props.dispatch(deliveryAddressFormUpdate({ prop: 'address', value: e.value.description }));
                                }
                            }}
                        />
                        <div className="input-email-window">
                            <p className="field-label">Special Instructions:</p>
                            <input 
                                type="text"
                                className="text-field-input"
                                placeholder="Special instructions for our drivers..."
                                value={this.props.instructions}
                                onChange={(e) => this.props.dispatch(deliveryAddressFormUpdate({ prop: 'instructions', value: e.target.value }))}
                            />
                        </div>

                        <div className="account-button in-receipt usual-orders update-modal-margin"
                            onClick={this.onAddDeliveryAddressButtonPress}
                        >
                            <img src={housecurrent} loading="lazy" className="button-icon white " />
                            {/* <HouseIcon style={styles.buttonIconWhite} fill="#fff" width="15" height="15" /> */}
                            <div>Add Address</div>
                         </div>
                    </div>
                </div>
            </div>
        );
    }
}

// const styles = StyleSheet.create({
//     container: {
//         flex: 1,
//         backgroundColor: '#FFFFFF',
//     },
//     closeButtonContainer: {
//         flex: 1,
//     },
//     addressButtonPadding: {
//         paddingRight: 20
//     },
//     closeButtonWrapper: {
//         maxWidth: '100%',
//         backgroundColor: '#ffffff'
//     },
//     closeButtonWInlineBlock: {
//         display: 'flex',
//         width: 50,
//         height: 50,
//         marginTop: 0,
//         marginRight: 0,
//         marginLeft: 0,
//         justifyContent: 'center',
//         alignItems: 'center',
//         borderWidth: 3,
//         borderColor: '#fff',
//         borderTopLeftRadius: 50,
//         borderBottomRightRadius: 50, 
//         borderTopRightRadius: 0,
//         borderBottomLeftRadius: 0,
//         fontFamily: 'sans-serif',      
//         color: '#111',
//         fontSize: 22,
//         fontWeight: '300',
//         maxWidth: '100%',
//         flexDirection: 'row',    
//     },
//     image3: {
//         width: 20,
//         height: 20,
//     },
//     headingInItem: {
//         flexDirection: 'row',
//         marginTop: 0,
//         marginBottom: 5, 
//         paddingLeft: 20, // 0 
//         textTransform: 'none',
//         marginBottom: 5, 
//         fontSize: 22, 
//         lineHeight: 30, 
//         fontWeight: 'bold'
//     },
//     finePrint2: {
//         marginTop: 5, 
//         fontSize: 9,
//         paddingLeft: 20,
//         fontWeight: '500',
//         fontFamily: Platform.OS === 'android' ? FONT_ANDROID_MEDIUM : undefined,
//         textTransform: 'uppercase'
//     },
//     h3HeaderNoTopPad: {
//         marginBottom: 10,
//         fontSize: 18, 
//         fontWeight: '600',
//         fontFamily: Platform.OS === 'android' ? FONT_ANDROID_BOLD : undefined,
//         letterSpacing: 0,
//     },
//     userInfo: {
//         paddingLeft: 20,
//         paddingTop:20,
//     },
//     profileInfoForm1: {
//         marginTop: 0,
//         marginRight: 0,
//         marginLeft: 0, 
//         marginBottom: 15,
//         paddingRight: 20,
//         position: 'relative',
//         zIndex: 102
//     },
//     profileInfoForm2: {
//         marginTop: 0,
//         marginRight: 0,
//         marginLeft: 0, 
//         marginBottom: 15,
//         paddingRight: 20,
//         position: 'relative',
//         zIndex: 101
//     },
//     textFieldWInput: {
//         maxHeight: 40, 
//         marginTop: 10, 
//         marginBottom: 10, 
//         paddingRight: 20, 
//         paddingLeft: 20, 
//         borderRadius: 300, 
//         borderColor: '#fff',
//          backgroundColor: '#fff',
//         shadowColor: "#000",
//         shadowOffset: {
// 	        width: 1,
// 	        height: 1,
//         },
//         shadowOpacity: 0.19,
//         shadowRadius: 1,
//         elevation: 4,
//         textAlign: 'left',
//     },
//     buttonInReceiptUsualOrders: {
//         padding:13,
//          backgroundColor: 'white',
//          paddingRight: 50,
//          paddingLeft: 50,
//          borderRadius: 20,
//          flexDirection: 'row',
//          marginTop: 5, 
//          marginBottom: 5, 
//          alignItems: 'center',
//          justifyContent: 'center',
//          color:'red',
//          backgroundColor: '#3a81b7',
//          fontSize: 12,
//          fontWeight: '400',
//          textAlign: 'center',
//          zIndex: 100
//      },
//      buttonIconWhite: {
//         flexDirection: 'row',
//         height: 15, 
//         marginRight: 10,
//     },
//     updateProfileButtonText: {
//         fontSize: 14, 
//         fontWeight: '700',
//         textAlign: 'center',
//         letterSpacing: 1,
//          textTransform: 'none',
//          color: 'white',
//     },
// });

const mapStateToProps = (state) => {

    return {
        token: state.auth.token,
        address: state.deliveryAddressForm.address,
        lat: state.deliveryAddressForm.lat,
        lng: state.deliveryAddressForm.lng,
        instructions: state.deliveryAddressForm.instructions,
        loading: state.deliveryAddressForm.loading,
        error: state.deliveryAddressForm.error
    };
};

export default connect(mapStateToProps)(NewDeliveryAddress);
